"use client";

import { c as _c } from "react/compiler-runtime";
import { Image } from "@/components/Image";
import { EmptyState } from "@/components/ui/EmptyState";
import { Button } from "@/components/ui/Button";
import { IconButton } from "@/components/ui/IconButton";
import { ImageOff, Minus, Plus } from "lucide-react";
import { useRef, useState } from "react";
export function ImageDocumentPreview(t0) {
  const $ = _c(28);
  const {
    src,
    title
  } = t0;
  const [zoom, setZoom] = useState(1);
  const [failed, setFailed] = useState(false);
  const viewport = useRef(null);
  const t1 = zoom <= 1 || failed;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setZoom(_temp);
    t3 = <Minus />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1) {
    t4 = <IconButton label="Zoom out" type="button" disabled={t1} onClick={t2}>{t3}</IconButton>;
    $[2] = t1;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== zoom) {
    t5 = Math.round(zoom * 100);
    $[4] = zoom;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <span className="min-w-14 text-center text-sm tabular-nums text-text-secondary" aria-live="polite">{t5}%</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = zoom >= 4 || failed;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setZoom(_temp2);
    t9 = <Plus />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7) {
    t10 = <IconButton label="Zoom in" type="button" disabled={t7} onClick={t8}>{t9}</IconButton>;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Button type="button" variant="ghost" onClick={() => {
      setZoom(1);
      viewport.current?.scrollTo(0, 0);
    }}>Fit image</Button>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t6) {
    t12 = <div className="flex shrink-0 items-center justify-center gap-2 border-b border-border-primary p-2" role="group" aria-label="Image inspection controls">{t4}{t6}{t10}{t11}</div>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t6;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `${title} image preview. Zoom in, then scroll or use arrow keys to pan.`;
  let t14;
  if ($[17] !== failed || $[18] !== src || $[19] !== title || $[20] !== zoom) {
    t14 = failed ? <EmptyState compact={true} tone="danger" icon={ImageOff} title={"This image couldn\u2019t be loaded"} /> : <div className="relative" style={{
      width: `${zoom * 100}%`,
      height: `${zoom * 100}%`
    }}><Image src={src} alt={title} fill={true} unoptimized={true} sizes="(max-width: 1280px) 92vw, 1152px" className="object-contain p-4" onError={() => setFailed(true)} /></div>;
    $[17] = failed;
    $[18] = src;
    $[19] = title;
    $[20] = zoom;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <div ref={viewport} className="min-h-0 flex-1 overflow-auto focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" tabIndex={0} role="region" aria-label={t13}>{t14}</div>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t12 || $[26] !== t15) {
    t16 = <div className="flex h-full min-h-0 w-full flex-col bg-bg-primary">{t12}{t15}</div>;
    $[25] = t12;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  return t16;
}
function _temp2(value_0) {
  return Math.min(4, value_0 + 0.5);
}
function _temp(value) {
  return Math.max(1, value - 0.5);
}